// @ts-ignore untyped module
import { getChatHeadingResponders } from '../../responders/selectors/getChatHeadingResponders';
// @ts-ignore untyped module
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getIsSalesbotChatflow } from '../../selectors/widgetDataSelectors/getIsSalesbotChatflow';
import { getIsHumanAgentAssigned } from '../../responders/selectors/getIsHumanAgentAssigned';
import { getAssignedAgentId } from '../../threads/operators/threadGetters';
export const getEnableAIDisclaimer = state => {
  const selectedThread = getSelectedThread(state);
  const assignedAgentId = getAssignedAgentId(selectedThread);
  const chatHeadingResponders = getChatHeadingResponders(state);
  const isResponderAI = chatHeadingResponders.some(responder => responder.get('isResponderAI')) || getIsAIChatbot(state) && assignedAgentId === null;
  return getIsSalesbotChatflow(state) && !getIsHumanAgentAssigned(state) || isResponderAI;
};